import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/catch';
import {_UserService} from '../services/user.service';

@Injectable()

export class ForbiddenHttpInterceptor implements HttpInterceptor {
  constructor(private user:_UserService, private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const dupReq = req.clone({
      setHeaders: {
        "X-Requested-With": 'XMLHttpRequest'
      }
     });
    return next.handle(dupReq)
    .catch((error, caught) => {
      if(error.status === 401) {
        this.user.logout();
        this.router.navigateByUrl('/login')
      }
      return Observable.throw(error)
    }) as any;
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/interceptors/http.interceptor.ts